export enum InvoicePolicyTypes{
    AfterCompletingJob = 1,
    AfterTotalReaches = 2,
}